import { createApp } from 'vue'

import Cookies from 'js-cookie'

import 'element-plus/dist/index.css'

import 'dayjs/locale/zh-cn';// 中文语言
import { dayjs } from 'element-plus';
import '@/assets/styles/reset.css' // global css
import '@/assets/styles/element.scss'
import App from './App'
import store from './store'
import router from './router'
import directive from './directive' // directive

// 注册指令
import plugins from './plugins' // plugins
import { download } from '@/utils/request'

// svg图标
import 'virtual:svg-icons-register'

import './permission' // permission control


//注册全局echarts
import ECharts from 'vue-echarts';
import 'echarts';
//vxeTable
import 'xe-utils'
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
// import animated from 'animate.css';
function useTable (app) {
  app.use(VXETable)
}
const app = createApp(App)

// 分页组件
import Pagination from '@/components/Pagination'

// 全局组件挂载
app.component('v-chart', ECharts);
app.component('Pagination', Pagination)


app.use(router)
app.use(store)
app.use(plugins)
app.use(useTable)
// app.use(animated)

directive(app)
dayjs.locale('zh-cn')
app.mount('#app')
